<template>
  <div class="adding">
    <div class="title-default">
      <i class="goback" @click="$router.go(-1)">我的商品</i> /
      <span>{{ $route.query.id != null ? "修改商品" : "添加商品" }}</span>
    </div>
    <div class="adding-content">
      <div class="label-default">
        <div class="input-title"><span class="xing">*</span>商品类别</div>
        <el-cascader
          class="default-input"
          v-model="goodsType"
          :options="goodsTypeList"
          :props="goodsTypeProps"
        ></el-cascader>
      </div>
      <div class="label-default">
        <div class="input-title"><span class="xing">*</span>商品名称</div>
        <el-input
          class="default-input"
          v-model="goddsName"
          placeholder="请选择"
        ></el-input>
      </div>
      <div class="label-default">
        <div class="input-title">店铺商品链接</div>
        <el-input
          class="default-input"
          v-model="goodsUrl"
          placeholder="请输入"
        ></el-input>
      </div>
      <div class="label-default">
        <div class="input-title">商品描述</div>
        <el-input
          class="default-input add-textarea"
          v-model="description"
          type="textarea"
          placeholder="请选择"
        ></el-input>
      </div>

      <div class="add-upload label-default">
        <div class="input-title"><span class="xing">*</span>商品图片</div>
        <div class="upload-modify">
          <a-upload
            :action="baseApl + '/common/common/upload_file'"
            listType="picture-card"
            :fileList="fileList"
            @preview="handlePreview"
            @change="handleChange"
          >
            <div v-if="fileList.length < 1">
              <a-icon type="plus" />
              <div class="ant-upload-text">图片</div>
            </div>
          </a-upload>
          <a-modal
            :visible="previewVisible"
            :footer="null"
            @cancel="handleCancel"
          >
            <img alt="example" style="width: 100%" :src="previewImage" />
          </a-modal>
        </div>
      </div>

      <div class="label-default">
        <div class="input-title">安装视频</div>
        <a-upload
          :action="baseApl + '/common/common/upload_file'"
          :multiple="true"
          :fileList="videoList"
          @change="videoChange"
          :beforeUpload="beforeVideoUpload"
        >
          <!-- <svg
            class="icon iconz_pop_close"
            aria-hidden="true"
            @click="deleteVideo(index)"
          >
            <use xlink:href="#iconz_pop_close" />
          </svg> -->
          <a-button v-if="videoList.length < 1">
            <a-icon type="upload" />安装视频（选传）
          </a-button>
        </a-upload>
      </div>
      <el-button class="add-submit" @click="addGoods()">提交</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      goddsName: "",
      goodsUrl: "",
      description: "",
      installVideoUrl: "",
      imgUrl: "",
      goodsType: [],
      previewImage: "",
      previewVisible: false,
      fileList: [],
      videoList: [],
      goodsTypeList: [],
      goodsTypeProps: { expandTrigger: "hover", value: "id", label: "name" },
      goodsData: [],
      goodsTypeProps: { expandTrigger: "hover", value: "id", label: "name" },
      baseApl: process.env.VUE_APP_BASE_API,
    };
  },
  mounted() {
    var _this = this;
    // 获取商品类别
    this.$fetch(`/common/api/goods_type`).then((res) => {
      let imgurl = {};
      if (res.code == "0") {
        _this.goodsTypeList = res.data;
        // 修改商品的初始化
        if (_this.$route.query.id != null) {
          // let goodsType = [];
          this.$post(`/user/api/goods/get?id=${_this.$route.query.id}`).then(
            (res) => {
              if (res.code == 0) {
                _this.goddsName = res.data.name;
                _this.goodsUrl = res.data.shopUrl;
                _this.description = res.data.description;
                _this.goodsType = res.data.goodsTypeId;
                _this.goodsData = res.data;
                _this.fileList.push({
                  uid: "-1",
                  name: res.data.name,
                  status: "done",
                  url: res.data.imgUrl,
                  response: { data: { url: res.data.imgUrl } },
                });
                if (res.data.installVideoUrl != "") {
                  _this.videoList.push({
                    uid: "-1",
                    name: res.data.name,
                    status: "done",
                    url: res.data.installVideoUrl,
                    response: { data: { url: res.data.installVideoUrl } },
                  });
                }
              } else {
                this.$message(res.message);
              }
            }
          );
        }
      } else {
        this.$message(res.message);
      }
    });
  },

  methods: {
    // 判断上传是否为图片
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      if (!isJPG) {
        this.$message.error("图片只能上传jpg、png格式");
      }
      //   const isLt2M = file.size / 1024 / 1024 < 2
      //   if (!isLt2M) {
      //     this.$message.error('Image must smaller than 2MB!')
      //   }

      return isJPG;
    },
    // 判断上传是否为视频
    beforeVideoUpload(file) {
      console.log(file);
      const isVideo = file.type === "video/mp4";
      if (!isVideo) {
        this.$message.error("视频只能上传mp4格式");
      }
      const isLt100M = file.size / 1024 / 1024 < 100;
      if (!isLt100M) {
        this.$message.error("视频不能超过100M");
        this.videoList = [];
      }

      return isVideo && isLt100M;
    },
    // 添加商品
    addGoods() {
      this.$message.closeAll()
      var _this = this;
      if (_this.$route.query.id != null) {
        this.$post(`/user/api/goods/modify`, {
          id: _this.$route.query.id,
          goodsTypeId: typeof _this.goodsType=='object'?_this.goodsType[_this.goodsType.length - 1]:_this.goodsType,
          name: _this.goddsName,
          shopUrl: _this.goodsUrl,
          description: _this.description,
          installVideoUrl:
            _this.videoList.length == 0
              ? ""
              : _this.videoList[0].response.data.url,
          imgUrl:
            _this.fileList.length == 0
              ? ""
              : _this.fileList[0].response.data.url,
        }).then((res) => {
          if (res.code == 0) {
            this.$message({
              message: res.message,
              type: "success",
            });
            this.$router.back(-1);
          } else {
            this.$message(res.message);
          }
        });
      } else {
        this.$post(`/user/api/goods/add`, {
          goodsTypeId: _this.goodsType[_this.goodsType.length - 1],
          name: _this.goddsName,
          shopUrl: _this.goodsUrl,
          description: _this.description,
          installVideoUrl:
            _this.videoList.length == 0
              ? ""
              : _this.videoList[0].response.data.url,
          imgUrl:
            _this.fileList.length == 0
              ? ""
              : _this.fileList[0].response.data.url,
        }).then((res) => {
          if (res.code == 0) {
            this.$message({
              message: res.message,
              type: "success",
            });
            this.$router.back(-1);
          } else {
            this.$message(res.message);
          }
        });
      }
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    handleChange({ fileList }) {
      // if (
      //   fileList[0].type === "image/jpeg" ||
      //   fileList[0].type === "image/png"
      // ) {
      this.fileList = fileList;
      // }
    },
    videoChange(info) {
      // videoChange( {fileList} ) {
      // this.videoList = fileList;

      let fileList = [...info.fileList];
      fileList = fileList.slice(-1);
      fileList = fileList.map((file) => {
        if (file.response) {
          // Component will show file.url as link
          file.url = file.response.url;
        }
        return file;
      });
      // 判断上传视频大小
      if (fileList[0].size / 1024 / 1024 < 100) {
        if (
          fileList[0].type === "video/mp4" &&
          !fileList[0].size / 1024 / 1024 < 100
        ) {
          this.videoList = fileList;
        } else {
          return;
        }
      } else {
        return;
      }
      $(".anticon-close").click(() => {
        this.videoList = [];
      });
    },
  },
};
</script>
<style lang="scss">
// .my_order .order_main .order_left {
//   margin-bottom: 100px;
// }
.ant-btn:hover,
.ant-btn:focus {
  border-color: #3455d3 !important;
  color: #3455d3 !important;
}
.anticon-upload {
  color: #3455d3;
}
.ant-btn {
  border-radius: 2px !important;
}
.title-default {
  height: 66px;
  color: #5e6066;
  font-size: 18px;
  padding: 24px 20px;
  line-height: 1;
  span {
    color: #909399;
  }
}
.label-default {
  margin-bottom: 24px;
  .input-title {
    color: #5e6066;
    height: 14px;
    line-height: 1;
    height: 14px;
    margin-bottom: 10px;
    .xing {
      color: #f75658;
      margin-right: 4px;
    }
  }
  .default-input {
    width: 372px;
    height: 40px;
    input,
    textarea {
      width: 100%;
      height: 100%;
    }
    .el-input .el-input__suffix {
      width: auto;
    }
    .el-textarea__inner {
      resize: none;
      border-radius: 2px;
    }
  }
  .add-textarea {
    width: 547px;
    height: 130px;
  }
}
</style>
<style lang="scss" scoped>
.adding {
  background: #ffffff;
  .adding-content {
    padding: 16px 20px 24px 20px;
  }
  .add-submit {
    width: 167px;
    height: 30px;
    background: rgba(52, 85, 211, 1);
    border-radius: 2px;
    padding: 0;
    color: #ffffff;
    font-size: 14px;
    margin-top: 8px;
  }
  &/deep/.ant-upload-list-item-info {
    span {
      width: 100%;
      height: 100%;
    }
  }
  &/deep/.ant-upload-list {
    width: 120px !important;
  }
  &/deep/.ant-upload-list-item {
    .ant-upload-list-item-info {
      & > span {
        display: flex;
      }
    }
  }
  &/deep/.upload-modify {
    width: 100px;
  }
}
</style>
